import React from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  IconButton,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Cards7 from "src/components/lineup/Cards7";

const LineupsPage = () => {
  const positions = ["C", "LW", "RW", "D", "D", "C/LW/RW/D", "Team"];
  const navigate = useNavigate();

  const lineups = [{ id: 1, name: "NHL Fantasy Lineup" }];

  const handleAddLineup = () => {
    navigate("/dashboard/lineups/new");
  };
  const handleEditLineup = (lineupId) => {
    navigate(`/dashboard/lineups/edit/${lineupId}`);
  };

  return (
    <Container sx={{ mt: 5 }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ mb: 5 }}>
          Lineups Setup
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: "70px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{ borderRadius: "10px", height: 52, minWidth: 200 }}
            startIcon={<AddIcon />}
            onClick={handleAddLineup}
          >
            Add New Lineup
          </Button>
        </Box>
      </Box>

      {lineups.map((lineup) => (
        <Paper
          key={lineup.id}
          sx={{
            maxWidth: "750px",
            borderRadius: "20px",
            padding: "24px",
            boxShadow: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" fontSize="20px">
              {lineup.name}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-start",
              }}
            >
              <IconButton onClick={() => handleEditLineup(lineup.id)}>
                <img
                  src="/assets/icons/EditIcon.svg"
                  alt="edit"
                  width={24}
                  height={24}
                />
              </IconButton>
              <IconButton>
                <img
                  src="/assets/icons/DeleteIcon.svg"
                  alt="delete"
                  width={24}
                  height={24}
                />
              </IconButton>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            ml="40px"
          >
            <Cards7 />
            <Box sx={{ flex: 1, ml: 10 }}>
              {positions.map((pos, idx) => (
                <Grid
                  container
                  key={idx}
                  spacing={1}
                  sx={{ mb: 1, alignItems: "center" }}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#6A707E",
                        fontFamily: "Circular Std, sans-serif",
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "30px",
                        letterSpacing: "0px",
                      }}
                    >
                      <span>{idx + 1}</span>
                      <span style={{ marginLeft: "30px" }}>{pos}</span>
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Box>
        </Paper>
      ))}
    </Container>
  );
};

export default LineupsPage;
